import { CurrencyLocale } from '@/i18n/models';
import type { IntlNumberFormat } from 'vue-i18n';
import { NumberFormatNames } from '@/i18n/models/NumberFormatNames';

const { NL, EN } = CurrencyLocale;
const { Currency, Number, NumberWith2Decimals, RoundedNrNoGrouping, RoundedNumber } = NumberFormatNames;

export const numberFormats: Record<string, IntlNumberFormat> = {
  [NL]: {
    [Currency]: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    [Number]: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    [NumberWith2Decimals]: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    [RoundedNumber]: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    [RoundedNrNoGrouping]: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: false
    }
  },
  [EN]: {
    [Currency]: {
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    [Number]: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    },
    [NumberWith2Decimals]: {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    },
    [RoundedNumber]: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    },
    [RoundedNrNoGrouping]: {
      style: 'decimal',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
      useGrouping: false
    }
  }
};
